import {z} from 'zod';

export const VettingsPageMetaSchema = z.object({
  tabCounts: z.record(z.number()).optional(),
  totalCount: z.number().optional(),
  pagination: z
    .object({
      currentPage: z.number(),
      totalPages: z.number(),
    })
    .optional(),
});

export const VettingsPageSchema = z.object({
  data: z.array(z.any()),
  meta: VettingsPageMetaSchema.optional(),
});

export type VettingsPage = z.infer<typeof VettingsPageSchema>;
